module.exports = __webpack_public_path__ + "media/tile-placeholder-backdrop.2e0c0ac5.png";